module.exports = __webpack_public_path__ + "img/question-white.70158b71.svg";